import SLSFamiliaMaterialClient from '@/api/SistemaDKP/sls-familia-material.client';
import { ErrorMessage } from '@/libs/Error';

export default class SLSFamiliaMaterialService {
  constructor() {
    this.client = new SLSFamiliaMaterialClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Familia Material');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Familia Material');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Familia Material');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Familia Material');
    }
  }
}
